import { Vehicle } from "./Vehicle";
import { Voucher } from "./Voucher";

export class Discharge {
  _id: string;
  id: number;
  date: Date;
  amount: number;
  person: number;
  user_name: string;
  razon_social: string;
  vehicle: number;
  vehicle_name: string;
  tankId: number;
  fuelId: number;
  fuel_name: string;
  status: number; // 0 -> success, other -> error
  voucherId: number;
  voucher_description: string;
  tankAvailable: string;
  dischargeInProgress?: boolean;
  kilometers: number;
  hours: number;
  lat?: number;
  lon?: number;
  voucher_id: Voucher;
  vehicle_id: Vehicle;
}
